import { createContext } from "react";

export const defaultOpenDrawerWidth = 260;
export const defaultAppBarHeight = 64;

export const saitfecoreNs = "fecore";

export const ModuleContext = createContext("NXXXX");
